export const postMessageToParentWindow = (data: any) => {
  if (window?.parent) {
    window.parent.postMessage(data, "*");
  }
};

export const closeIFrame = () => {
  postMessageToParentWindow({ eventType: "cancel" });
};
